document.addEventListener("DOMContentLoaded", function() {
    // Vérification que les éléments existent sur la page avant de manipuler le DOM
    const videoPopup = document.getElementById("videoPopup");
    const closeButton = document.getElementById("closeVideo");

    // Vérifie si les éléments existent avant de continuer
    if (!videoPopup || !closeButton) {
        console.log("Éléments vidéo ou bouton non trouvés. Le script s'arrête.");
        return;  // Arrête l'exécution du script si les éléments sont manquants
    }

    // Vérifie si la vidéo a déjà été vue
    if (!localStorage.getItem("videoSeen")) {
        console.log("La vidéo ne semble pas encore avoir été vue.");
        setTimeout(() => {
            videoPopup.classList.add("active");
            console.log("Pop-up activé !");
        }, 1000); // Affiche après 1s
    } else {
        console.log("La vidéo a déjà été vue, elle ne s'affichera pas.");
    }

    // Fermer la vidéo en cliquant sur le bouton
    closeButton.addEventListener("click", function() {
        videoPopup.classList.remove("active");
        // Marquer la vidéo comme vue dans le localStorage
        localStorage.setItem("videoSeen", "true");
        console.log("Vidéo fermée, marquée comme vue.");
    });

    // Fermer la vidéo en cliquant à l'extérieur
    videoPopup.addEventListener("click", function(e) {
        if (e.target === videoPopup) {
            videoPopup.classList.remove("active");
            // Marquer la vidéo comme vue dans le localStorage
            localStorage.setItem("videoSeen", "true");
            console.log("Vidéo fermée, marquée comme vue.");
        }
    });
});
